import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { HttpService } from './http.service'
import { ConfigService } from './config.service';
import { StorageService } from './storage.service';
import { AdminTicketDto, FirstPasswordRequestDto, LoginSsoRequestDto, LostPasswordRequestDto, RefreshTokenRequestDto, TokenDto } from './auth.dto';

const API_EXT = '/auth/'

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  
  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private configService: ConfigService,
    private storageService:StorageService,
    ) {
  }

  private get api_url(): string {
    const base = this.configService.getApiBaseUrl(); // OK si config chargée
    return base + API_EXT;
  }


  login(username: string, password: string): Observable<TokenDto> {

    const body = new HttpParams()
        .set('username', username)
        .set('password', password)
        .set('grant_type', 'password');
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<TokenDto>(
      this.api_url + 'login',
      body,
      { headers }
    );
  }

  /** Remplace le mot de passe temporaire et ouvre la session. **/
  firstPassword(request: FirstPasswordRequestDto): Observable<TokenDto> {
    return this.http.post<TokenDto>(
      this.api_url + 'first-password',
      request,
      httpOptions
    );
  }

  login_sso(code: string, origin: string, codeVerifier: string): Observable<TokenDto> {
    const request: LoginSsoRequestDto = {
      code,
      origin,
      code_verifier: codeVerifier
    }

    return this.http.post<TokenDto>(
      this.api_url + 'sso',
      request,
      httpOptions
    );
  }

  logout(): Observable<void> {
    return this.http.post<void>(this.api_url + 'logout', { }, httpOptions);
  }

  lostpassword(username: string): Observable<void> {
    const request: LostPasswordRequestDto = {
      username
    }

    return this.http.post<void>(this.api_url + 'lostpassword',
      request,
      httpOptions
    );
  }

  /** Demande un ticket a usage unique pour ouvrir l'administration. **/
  requestAdminTicket(): Observable<AdminTicketDto> {
    return this.http.post<AdminTicketDto>(
      this.api_url + 'admin-ticket',
      {},
      httpOptions
    );
  }

  refreshToken(refreshToken: string, clientSecurity: string): Observable<TokenDto> {
    const request: RefreshTokenRequestDto = {
      refresh_token: refreshToken,
      client_security: clientSecurity
    }

    return this.http.post<TokenDto>(this.api_url + 'refreshtoken',
      request,
      httpOptions
    );
  }
  private refreshInFlight?: Promise<string>;

  async refreshAccessTokenOnce(clientSecurity: string): Promise<string> {
    if (this.refreshInFlight) return this.refreshInFlight;

    const refreshToken = this.storageService.getRefreshToken?.() ?? null;
    if (!refreshToken) throw new Error('No refresh token');

    this.refreshInFlight = firstValueFrom(
      this.refreshToken(refreshToken, clientSecurity) // <-- ton call HttpClient existant
    )
      .then((token: TokenDto) => {
        this.storageService.saveAfterRefresh(token);
        return token.access_token;
      })
      .finally(() => {
        this.refreshInFlight = undefined;
      });

    return this.refreshInFlight;
  }
  
}